<template>
    <template-two-sidebars
        :title="pageInfos.title"
        :subtitle="pageInfos.subtitle"
        module-name="Relatórios"
    >
        <template #header-actions>
            <div class="header-actions">
                <div class="header-actions-input" :style="activePositionFixed">
                    <ui-menu-card icon="fal fa-cog">
                        <div class="menu-card">
							<button @click="$mx_oldPanelLinkButton('/relatorios/basicos')">Relatórios Excel</button>
                            <router-link :to="{ name: 'configurations.company.companydata' }" @click="generalConfigs">
                                Configurações Gerais
                            </router-link>
                        </div>
                    </ui-menu-card>
                </div>
            </div>
        </template>

        <template #sidebar-left>
            <side-menu-left />
        </template>

        <template #page>
            <router-view />
        </template>

        <side-menu-right />
    </template-two-sidebars>
</template>

<script>
	import templateTwoSidebars from '@/templates/page-configurations'
	import sideMenuLeft from './components/side-menu-left'
	import sideMenuRight from './components/side-menu-right'

	import { uiMenuCard } from "@/components/ui"

	import helpers from '@/mixins/helpers'

	export default {
		name: 'ui-basics-report',

		components: {
			templateTwoSidebars,
			sideMenuLeft,
			sideMenuRight,
			uiMenuCard,
		},

		mixins: [helpers],

		data() {
			return {
				activePositionFixed: false,
				pageInfos: {},
			}
		},

		computed: {
			positionFixed() {
				return this.activePositionFixed === true ? `position: fixed; right: 0` : ''
			}
		},

		created() {
			this.$root.$on('set-new-reports', response => {
				this.prepareSubtitle(response)
			})

			this.$root.$on('show-filters', response => {
				this.activePositionFixed = response.length > 0
			})

        	this.$root.$on('close-filters', response => {
				this.activePositionFixed = response
			})

			this.pageInfos = this.$route.meta.infos
		},

		beforeDestroy() {
			this.$root.$off('set-new-reports')
			this.$root.$off('show-filters')
			this.$root.$off('close-filters')
		},

		methods: {
			/**
			 * Define o título de acordo com o tipo do grupo de relatórios
			 */
			prepareSubtitle(title) {
				this.pageInfos.subtitle = title
					? 'Relatórios de ' + title.charAt(0).toUpperCase() + title.slice(1).toLowerCase()
					: ''
			},
			/**
			 * Trata o evento de quando é solicicitado abrir as configurações gerais
			 */
			generalConfigs() {
				this.$gtm.trackEvent({
					event: "fac_button_click",
					category: "vue-relatorio-planilhas-new",
					action: "click",
					label: "Configurações Gerais"
				})
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
